<template>
  <ResizablePage>
    <template v-slot:content="contentProps">
      <v-data-table
        :headers="headers"
        :items="contracts"
        :items-per-page="-1"
        :height="contentProps.tableHeight"
        tableProps.tableHeight
        fixed-header
        hide-default-header
        hide-default-footer
        :search="fastFilter"
        :item-class="rowStyle"
        :custom-filter="customFilter"
        @click:row="rowClick"
        @contextmenu:row="rowMenuClick"
      >
        <template v-slot:header="{ props }">
          <thead>
          <tr>
            <th v-for="header in props.headers" :key="header.value" :style="{ width: header.width, textAlign: header.align }">
              <div>{{ header.text1 }}</div>
              <div>{{ header.text2 }}</div>
            </th>
          </tr>
          </thead>
        </template>

        <template v-slot:[`item.vehicle`]="{ item }">
          <div>{{ item.vehicle.numericPlate }}</div>
          <div>&nbsp;</div>
        </template>
        <template v-slot:[`item.subject`]="{ item }">
          <div>{{ item.name }}</div>
          <div>{{ (item.subject !== null) ? item.subject.name : "-" }}</div>
        </template>
        <template v-slot:[`item.place`]="{ item }">
          <div>{{ formatPlace(item.fromPlace) }}</div>
          <div>{{ formatPlace(item.toPlace) }}</div>
        </template>
        <template v-slot:[`item.fromto`]="{ item }">
          <div>{{ formatDateTime(item.fromTimestamp) }}</div>
          <div>{{ formatDateTime(item.toTimestamp) }}</div>
        </template>
        <template v-slot:[`item.didu`]="{ item }">
          <div>{{ formatDistance(item.plannedDistance) }} / {{ formatDistance(item.actualDistance) }}</div>
          <div>{{ formatDuration(item.plannedDuration) }} / {{ formatDuration(item.actualDuration) }}</div>
        </template>
        <template v-slot:[`item.amount`]="{ item }">
          {{ formatAmount(item.amount, item.currencyCode) }}<br />
          {{ formatAmount(item.amountPerKm, item.currencyCode) }}
        </template>
      </v-data-table>

      <v-menu
        v-model="contextMenu"
        :position-x="contextMenuX"
        :position-y="contextMenuY"
        absolute
        offset-y
      >
        <v-list>
          <template v-for="(item, index) in contextItems">
            <v-divider class="mx-3" :key="index" v-if="item.topBorder" />
            <v-list-item v-if="item.enabled"
                         :key="index"
                         link
                         @click="rowMenuItemClick(item)"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </template>
        </v-list>
      </v-menu>
    </template>
  </ResizablePage>
</template>

<script>
//import Vue from "vue";
import ResizablePage from "@/components/ResizablePage";
import { DateTime, Duration } from "luxon";
import utils from "@/utils";

export default {
  name: "ContractsView",
  components: { ResizablePage },
  data() {
    return {
      mounted: false,
      contextMenu: false,
      contextMenuX: 0,
      contextMenuY: 0,
      contextContract: null,
      contextItems: [
        { name: "show-on-map", title: this.$t("table.contracts.context-menu.show-on-map"), enabled: true }
      ],

      headers: [
        {
          text1: this.$t("table.contracts.header.vehicle"),
          text2: "",
          align: "start",
          width: "8%",
          value: "vehicle"
        },
        {
          text1: this.$t("table.contracts.header.name"),
          text2: this.$t("table.contracts.header.subject"),
          align: "start",
          width: "16%",
          value: "subject"
        },
        {
          text1: this.$t("table.contracts.header.place_from"),
          text2: this.$t("table.contracts.header.place_to"),
          align: "start",
          width: "24%",
          value: "place"
        },
        {
          text1: this.$t("table.contracts.header.from"),
          text2: this.$t("table.contracts.header.to"),
          align: "start",
          width: "10%",
          value: "fromto"
        },
        {
          text1: this.$t("table.contracts.header.distance"),
          text2: this.$t("table.contracts.header.duration"),
          align: "start",
          width: "12%",
          value: "didu"
        },
        {
          text1: this.$t("table.contracts.header.amount"),
          text2: this.$t("table.contracts.header.amount_km"),
          align: "end",
          width: "8%",
          value: "amount"
        },
      ]
    };
  },

  computed: {
    fastFilter: function() {
      return this.$store.state.data.fastFilter;
    },

    contracts: function() {
      if (this.$store.state.data.records === null || this.$store.state.data.module !== "contract")
        return [];
      else
        return this.$store.state.data.records;
    }
  },

  methods: {
    customFilter(value, search, item) {
      let ls = search.toLowerCase();
      return (item.vehicle !== null && item.vehicle.numericPlate.toLowerCase().includes(ls))
        || (item.subject !== null && item.subject.name.toLowerCase().includes(ls))
        || (item.name !== null && item.name.toLowerCase().includes(ls));
    },

    rowClick(item) {
      this.$router.push({ name: "data/contract", params: { id: item.contractId } });
    },

    rowMenuClick(event, item) {
      this.contextMenuX = event.clientX;
      this.contextMenuY = event.clientY;
      this.contextMenu = true;
      this.contextContract = item.item;

      event.preventDefault();
    },

    rowMenuItemClick(item) {
      switch (item.name) {
        case "show-on-map":
          this.$router.replace({
            name: "map/contracts",
            params: { ccode: this.$store.state.auth.company.code, id: this.contextContract.vehicleId },
            query: { month: this.$store.state.data.month, contract: this.contextContract.contractId }
          });
          break;
      }
    },

    isActive(item) {
      return item.validTo === null || DateTime.fromISO(item.validTo) > DateTime.now();
    },

    // eslint-disable-next-line no-unused-vars
    rowStyle: function(item) {
      return "";
      /*
      if (this.isActive(item)) {
        return "";
      } else {
        return "table-row-hidden";
      }*/
    },

    formatDateTime(dt) {
      if (dt !== null)
        return DateTime.fromISO(dt).toLocaleString(DateTime.DATETIME_SHORT);
      else
        return "-";
    },

    formatDistance(distance) {
      if (distance !== null)
        return utils.formatDistance(distance);
      else
        return "-";
    },

    formatAmount(amount, currencyCode) {
      if (amount !== null)
        return utils.formatAmount(amount, currencyCode);
      else
        return "-";
    },

    formatDuration(duration) {
      if (duration !== null)
        return Duration.fromObject({ seconds: duration }).toFormat("h'h' m'm'");
      else
        return "-";
    },

    formatPlace(place) {
      if (place !== null)
        return place;
      else
        return "-";
    }
  },

  watch: {
    "$store.state.auth.company": function() {
      if (this.mounted)
        this.$store.dispatch("data/fetchRecords", { module: "contract" });
    }
  },

  mounted() {
    this.mounted = true;
    this.$store.dispatch("data/fetchRecords", { module: "contract" });
  },

  destroyed() {
    this.mounted = false;
  }
};
</script>

<style scoped>

</style>